export default "__VITE_ASSET__M$LnyfWl__"